import {Offsets} from '@mintdata/mint-kit/api/models/Offsets';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class OffsetsConverter extends BaseFieldConverter<Offsets>
{
    public static readonly VALUE:FieldPath = 'value';
    public static readonly LEFT:FieldPath = 'left';
    public static readonly TOP:FieldPath = 'top';
    public static readonly RIGHT:FieldPath = 'right';
    public static readonly BOTTOM:FieldPath = 'bottom';
}
